import {
  globalConstants,
  globalSystemConstants,
  subscriptionConstants,
} from "../../constants";

const { SUBSCRIPTION_PRICES } = subscriptionConstants;

const initialState = {
  subscriptionPrices: [],
};

const SubscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBSCRIPTION_PRICES + globalConstants.SUCCESS:
      return {
        ...state,
        subscriptionPrices: action.data,
      }; 
    case globalSystemConstants.SPINNER_ACTIVATE:
      return {
        ...state,
        spinnerActions: true,
      };
    case globalSystemConstants.SPINNER_DEACTIVATE:
      return {
        ...state,
        spinnerActions: false,
      };
    default:
      return state;
  }
};

export default SubscriptionReducer;
